import { IPrivateNote, IPrivateNoteData,ITableRes } from 'types'

import { baseApi } from './baseApi'

export const privateNotesAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_privateNotes: builder.query<ITableRes<IPrivateNote>, {assignment_id: string, params?: any}>({
      query: ({assignment_id, params={}}) => ({
        url: `/assignment-private-notes/${assignment_id}/`,
        params,
      }),
      providesTags: ['private-notes'],
    }),
    GET_privateNoteById: builder.query<IPrivateNote, {assignment_id: string, id: string}>({
      query: ({assignment_id, id}) => ({
        url: `/assignment-private-notes/${assignment_id}/${id}/`,
      }),
      providesTags: ['private-notes'],
    }),
    POST_privateNote: builder.mutation<IPrivateNote, {assignment_id: string, body: IPrivateNoteData}>({
      query: ({assignment_id, body}) => ({
        url: `/assignment-private-notes/${assignment_id}/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['private-notes','private-note'],
    }),
    PATCH_privateNote: builder.mutation<IPrivateNote, {assignment_id: string, id: string, body: IPrivateNoteData}>({
      query: ({assignment_id, id, body}) => ({
        url: `/assignment-private-notes/${assignment_id}/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['private-notes','private-note'],
    }),
    DELETE_privateNote: builder.mutation<IPrivateNote, {assignment_id: string, id: string}>({
      query: ({assignment_id, id}) => ({
        url: `/assignment-private-notes/${assignment_id}/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['private-notes'],
    }),
  }),
})

export const {
  useGET_privateNotesQuery,
  useGET_privateNoteByIdQuery,
  usePOST_privateNoteMutation,
  usePATCH_privateNoteMutation,
  useDELETE_privateNoteMutation,
} = privateNotesAPI
